<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="item-add" :class="{'extra-padding': showMoreExists, 'limited-height': (showMoreExists && !showMoreOpen)}">
    <div v-if="dataCard && dataCard.source && dataCard.source === 'DATASTORIES' && dataValues && dataValues.image && (dataValues.image.indexOf('data:image') !== -1 || dataValues.image.indexOf('http') !== -1)" class="image-wrapper">
      <img :src="dataValues.image" :alt="dataValues.responsibleIndicatorUnit ? dataValues.responsibleIndicatorUnit : 'datastory_prev'" class="img-icon">
    </div>
    <div v-if="dataCard && dataCard.source && dataCard.source === 'DOCS' && dataValues && dataValues.files.length !== 0">
      <div v-for="file in dataValues.files" :key="file.name">
        <DocumentAddition :data-file="file" :single="dataValues.files.length === 1" />
      </div>
    </div>
    <div v-if="dataCard && dataCard.source && dataCard.source === 'MAPS' && dataValues && dataValues.resources.length !== 0" class="addition-block">
      <div class="addition-block-title">
        <div class="addition-block-title-text">{{ $t('download_links') }}</div>
      </div>
      <div class="addition-block-options">
        <div
          v-for="(file, i) in dataValues.resources"
          :key="i"
          class="option-block"
        >
          <div class="addition-block-options-link" @click="() => download(file.linkAtom, file)">
            <div class="addition-block-options-icon file" />
            <!-- eslint-disable-next-line vue/no-parsing-error -->
            <div class="addition-block-options-text">{{ file.formatName + (file.nameNeighborhood || file.nameDistrict ? ' (' + (file.nameNeighborhood ? file.nameNeighborhood : file.nameDistrict) + ')' : '') }}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="dataCard && dataCard.source && dataCard.source === 'SURVEY' && dataValues && dataValues.documents.length !== 0" class="addition-block">
      <div class="addition-block-title">
        <div class="icon-folder" />
        <div class="addition-block-title-text">{{ $t('docs_lab') }}</div>
      </div>
      <div class="addition-block-options">
        <div
          v-for="file in orderedDocs"
          :key="file.id"
          class="option-block"
        >
          <div class="addition-block-options-link" @click="() => download(file.link, file)">
            <div class="addition-block-options-icon file" />
            <!-- eslint-disable-next-line vue/no-parsing-error -->
            <div v-tooltip="file.name" class="addition-block-options-text">{{ (file.name.length <= 30 ? file.name : file.name.slice(0, 27) + '...') }}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="dataCard && dataCard.source && dataCard.source === 'MICRODATA' && dataValues" class="addition-block">
      <div class="addition-block-title">
        <div class="addition-block-title-text">{{ $t('last_informed_date') + lastYear }}</div>
      </div>
      <div class="addition-block-options">
        <div
          v-for="file in filesForLastYear"
          :key="file.id"
          class="option-block"
        >
          <div class="addition-block-options-link" @click="() => download(file.url, file)">
            <div class="addition-block-options-icon file" />
            <!-- eslint-disable-next-line vue/no-parsing-error -->
            <div class="addition-block-options-text">{{ (file.name.length <= 23 ? file.name : file.name.slice(0, 20) + '...' + file.format.toLowerCase()) }}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="dataCard && dataCard.source && dataCard.source === 'MICRODATA' && dataValues" class="addition-block">
      <div class="addition-block-title">
        <div class="addition-block-title-text">{{ $t('additional') }}</div>
      </div>
      <div class="addition-block-options">
        <div class="option-button" @click="show('modal-additional-info')">{{ $t('additional_info') }}</div>
        <div v-if="dataValues.datasetFieldsDescription" class="option-button" @click="show('modal-complement-info')">{{ $t('complement_info') }}</div>
        <div v-if="definitionCamps.length !== 0" class="option-button" @click="show('modal-camp-definition')">{{ $t('camps_definition_title') }}</div>
      </div>
    </div>
    <div v-if="dataCard.license" class="addition-block">
      <div class="addition-block-title">
        <div class="addition-block-title-text">{{ $t('license') }}</div>
      </div>
      <div class="addition-block-options" :class="showMoreExists && 'extra-margin-bottom'">
        <a
          v-if="dataValues && dataValues.licenseUrl"
          :href="dataValues.licenseUrl"
          target="_blank"
          class="addition-block-options-link"
        >
          <div class="addition-block-options-icon exit" />
          <div class="addition-block-options-text">{{ dataCard.license }}</div>
        </a>
        <div v-else class="addition-block-options-text no-link-special-margin">{{ dataCard.license }}</div>
      </div>
    </div>
    <div v-if="showMoreExists" class="show-more-container">
      <span @click="toggleShowMore">{{ showMoreOpen ? $t('show_less') : $t('show_more') }}</span>
    </div>
  </div>
</template>

<script>
import DocumentAddition from './DocumentAddition.vue'
import { savedownload } from '../../services/api'
import $ from 'jquery'

/**
 * Display diferent icon logo depending on type
 * @example [none]
 */
export default {
  name: 'ItemAdditions',
  components: { DocumentAddition },
  props: {
    /**
     * Item object information getted from api
     */
    dataCard: {
      type: Object,
    },
    /**
     * Item object information getted from opendata-ajuntament
     */
    dataValues: {
      type: Object,
    },
    /**
     * Array table definition camps
     */
    definitionCamps: {
      type: Array,
    },
    /**
     * Array of files of last year
     */
    filesForLastYear: {
      type: Array,
    },
    /**
     * Last year published date
     */
    lastYear: {
      type: String,
    },
  },
  data() {
    return {
      showMoreExists: false,
      showMoreOpen: false,
    }
  },
  computed: {
    orderedDocs() {
      let docs = this.dataValues.documents
      docs.sort((a, b) => {
        if (a.name < b.name) {
          return -1
        }
        if (a.name > b.name) {
          return 1
        }
        return 0
      })
      return docs
    },
  },
  mounted() {
    if ($('.item-add').height() > 250) {
      this.showMoreExists = true
    }
  },
  updated: function () {
    this.$nextTick(() => {
      if ($('.item-add').height() > 250) {
        this.showMoreExists = true
      }
      setTimeout(() => {
        if ($('.item-add').height() > 250) {
          this.showMoreExists = true
        }
      }, 500)
    })
  },
  methods: {
    download(url, file) {
      document.open(url, "", "noopener=true")
      savedownload(this.$route.params.lang, this.$route.params.cardId, file.name)
    },
    /**
     * Toggle show more option if item have more than max height
     */
    toggleShowMore() {
      this.showMoreOpen = !this.showMoreOpen
    },
    /**
     * Shows the modal recived by param
     * @param {String} val id of modal to open
     * @public This is a public method
     */
    show(val) {
      this.$modal.show(val)
    },
    /**
     * Change the information of table details and open the modal
     * @param {Object} file information of file clicked
     * @public This is a public method
     */
    changeDetailTableInfoAndOpenModal(file) {
      this.$emit('change-detail-table-info', file)
      this.show('modal-file-details')
    },
  },
}
</script>

<style lang="stylus" scoped>
.item-add
  position: relative
  overflow: hidden
  width: 100%
  padding: vw(20px) vw(20px) vw(30px)

  &:not(:last-child)
    margin-bottom: vw(20px)

  .image-wrapper
    width: 100%
    display: flex
    justify-content: center
    padding-bottom: 10px
    
    .img-icon
      width: 40%

  .show-more-container
    position: absolute
    bottom: 0
    left: vw(20px)
    padding: vw(15px) 0
    width: 100%
    background-color: white
    cursor: pointer

    span
      m-font-size(16, 22)
      color: $corporate_color
      font-weight: 400

.limited-height
  max-height: vw(280px)

.extra-padding
  padding-bottom: vw(35px)

.addition-block
  &:not(:last-child)
    margin-bottom: vw(20px)

  .extra-margin-bottom
    margin-bottom: vw(30px)

.addition-block-title
  display: flex
  align-items: center
  margin-bottom: vw(15px)

.addition-block-title-icon
  &.visibility
    m-icon("visibility-grey", 18)

.addition-block-title-text
  m-font-size(14, 18)
  font-weight: 600

.buttons-wrapper
  display: flex
  gap: vw(10px)

  .button-circle
    display: flex
    justify-content: center
    align-items: center
    width: vw(22px)
    height: vw(22px)
    border-radius: 50%
    background-color: $bcn-grey

    &:hover
      background-color: $bcn-light-grey

    .icon-preview
      m-icon("visibility-black", 16)

    .icon-text
      m-icon("text-black", 16)

.addition-block-options-link
  display: flex
  align-items: center
  cursor: pointer
  gap: vw(5px)

  &:hover
    .addition-block-options-text
      text-decoration: underline

.addition-block-options-text
  m-font-size(15, 19)
  color: $corporate_color

  &.no-link-special-margin
    margin-left: vw(14px)
    color: black

.addition-block-options-icon
  &.exit
    m-icon("exit-blue", 20, $corporate_color)

  &.file
    m-icon("file-small", 20, $corporate_color)

  + .addition-block-options-text
    margin-top: 0.1em

.option-button
  m-font-size(15, 19)
  color: $corporate_color
  cursor: pointer

  &:not(:last-child)
    margin-bottom: vw(10px)

.option-block
  display: flex

  &:not(:last-child)
    margin-bottom: vw(10px)

  .buttons-wrapper
    display: flex

    .button-icon:hover
      border: none
      background-color: $bcn-other-grey

    .button-icon
      display: flex
      justify-content: center
      align-items: center
      width: vw(22px)
      height: vw(22px)
      border: 1px solid black
      border-radius: 50%
      background-color: white
      cursor: pointer

      .info-icon
        m-icon("info", 16)

      .download-icon
        m-icon("download-black", 16)
</style>